package com.hyperether.goodjob.navigation

object WebNavigationState {
    val lastAccessedIds = mutableMapOf<String, String>()
}